module.exports = __webpack_public_path__ + "static/sofia-ac8a56cf47b56b0e1a2761c221e3a7ff.svg";